import type { CalendarPlatform } from 'src/meetings/models';
import GoogleLarge from '../assets/platforms/large/google.svg';
import OutlookLarge from '../assets/platforms/large/outlook.svg';
import GoogleMeetSmall from '../assets/platforms/small/googlemeet.svg';
import AfternoonSmall from 'src/UI/icons/logo/smallLogo.svg';
import AfternoonLarge from 'src/UI/icons/logo/squareLogo.svg';
import TeamsSmall from '../assets/platforms/small/teams.svg';

type Props = {
  platform: CalendarPlatform;
  variant?: 'small' | 'large';
  size?: number;
};

const platformIcons = {
  small: {
    GOOGLE: GoogleMeetSmall,
    MICROSOFT: TeamsSmall,
    AFTERNOON: AfternoonSmall,
  },
  large: {
    GOOGLE: GoogleLarge,
    MICROSOFT: OutlookLarge,
    AFTERNOON: AfternoonLarge,
  },
} as const;

export const CalendarAccountIcon = ({ platform, variant = 'large', size }: Props) => {
  const iconSize = size ?? (variant === 'large' ? 40 : 16);
  const icon = platformIcons[variant][platform];
  return <img src={icon} alt={platform} width={iconSize} height={iconSize} />;
};
